import React, {FC} from 'react';
import {z} from "zod";
import PullOverForm from "@components/pullover/PullOverForm.component";
import {ImplementFormProps} from "@components/form/Form.component";
import {CreateExtraInput, CreateExtraMutation} from "@src/gql-schema";
import {FormFields} from "@components/form/fields/FormField.component";
import useGql from "@modules/graphql/useGql";
import {OpenState} from "@app/types/States";
import {ExtraTypeOptions, ExtraWhenOptions} from "@app/entities/Extra.types";


const ExtraCreateForm: FC<ImplementFormProps<CreateExtraMutation> & {
    subscriptionId: string,
    openState: OpenState
}> = ({subscriptionId, onSubmitSuccess, openState}) => {
    const gql = useGql();

    const fields: FormFields<Omit<CreateExtraInput, 'subscriptionId'>> = {
        title: {
            zodType: z.string().min(1).max(64),
            fieldType: 'input',
            label: 'Title',
        },
        vatPercentage: {
            zodType: z.string().min(1).max(64),
            fieldType: 'input',
            label: 'vatPercentage',
        },
        value: {
            zodType: z.number({coerce: true}).min(0.01).step(0.01),
            fieldType: 'input',
            label: 'Amount',
            colSpan: 'col-span-3'
        },
        type: {
            zodType: z.string().min(1).max(64),
            fieldType: 'select',
            label: 'Type',
            options: ExtraTypeOptions,
            colSpan: 'col-span-4'
        },
        when: {
            zodType: z.string().min(1).max(64),
            fieldType: 'select',
            label: 'When',
            options: ExtraWhenOptions,
            colSpan: 'col-span-5'
        },
        description: {
            zodType: z.string().min(1).max(64),
            fieldType: 'textarea',
            label: 'Description'
        },
        active: {
            zodType: z.boolean(),
            fieldType: 'checkbox',
            label: 'Active',
            defaultValue: true
        },
    }

    const handleSubmitSuccess = async (values?: CreateExtraMutation) => {
        await onSubmitSuccess?.(values)
    }

    return (
        <>
            <PullOverForm
                title={'Create Extra (Addon)'}
                openState={openState}
                submit={{
                    title: 'Save'
                }}
                cancel={{
                    title: 'Cancel'
                }}
                form={{
                    submit: gql.CreateExtra,
                    onSubmitSuccess: handleSubmitSuccess,
                    fields: fields,
                    payloadInjection: {
                        subscriptionId
                    }
                }}
            />
        </>
    );
};

export default ExtraCreateForm;
